import { Component } from '@angular/core';
import {RoleService} from "@modules/private/admin/data/services/view/role.service";

@Component({
  selector: 'app-admin-role-form',
  templateUrl: './admin-role-form.component.html',
  styleUrls: ['./admin-role-form.component.scss']
})
export class AdminRoleFormComponent {
  constructor(
    public roleService: RoleService
  ) {
  }

  get e() {
    return this.roleService.entity
  }
}
